const $btn = $('.js-load-all-publications');
const $foot = $('.js-load-all-publications-foot');
const $list = $('.js-publications-items');

if ($btn.length && $foot.length && $list.length) {
	$btn.on('click', function (e) {
		e.preventDefault();

		const offset = $list.children().length;
		const taxonomy = $btn.data('taxonomy') || '';
		const ajaxUrl = (window.woonAjax && window.woonAjax.url) || '/wp-admin/admin-ajax.php';

		$btn.addClass('is-loading');

		$.post(ajaxUrl, {
			action: 'load_all_publications',
			offset: offset,
			taxonomy: taxonomy,
		}, function (res) {
			if (res && res.success) {
				$list.append(res.data);
			}
			$foot.remove();
		}).fail(function () {
			$btn.removeClass('is-loading');
		});
	});
}
